var Backbone = require('backbone')
var Config = require('config')
var App = require('app')
var BaseModel = require('src/common/base-model')
var BaseCollection = require('src/common/base-collection')

var Events = function () {
  // init
  var Event = BaseModel.extend({
    urlRoot: Config.api.host + '/events',
    idAttribute: '_id',
    defaults: {
    },
    validation: {
    }
  })

  var EventsCollection = BaseCollection.extend({
    url: Config.api.host + '/events',
    model: Event,
    mode: 'infinite', //
    state: {
      pageSize: 50,
      firstPage: 0
    },
    parseLinks: function (resp, xhr) {
      // convert an object to a querystring
      var generateQueryString = function (params) {
        return Object.keys(params).map(function (key) {
          return key + '=' + params[key]
        }).join('&')
      }

      var nextParams = _.clone(xhr.data)

      var linksObject = {
        'next': ''
      }

      if (resp.skip + resp.limit < resp.total) {
        nextParams['$page']++
      }

      linksObject['next'] = this.url + '?' + generateQueryString(nextParams)

      // console.log(this.url)
      return linksObject
    }
  // parseState: function (resp, queryParams, state, options) {
  //   return {
  //     totalRecords: resp.total
  //   }
  // },
  // parse: function (data) {
  //   if (!data.data) return data
  //   return data.data
  // }
  })

  //
  var API = {
    getEventEntities: function (options) {
      var fetchParams = {
        reset: true
      // cache: true,
      // prefill: true,
      // expires: false
      }

      if (options) {
        if (options.query) fetchParams.data = options.query
      }

      var events = new EventsCollection([], options)
      events.fetch(fetchParams)
      return events
    },
    getEventEntity: function (id) {
      var event = new Event({_id: id})
      event.fetch()
      return event
    }
  }

  App.globalChannel.reply({
    'event:entities': API.getEventEntities,
    'event:entity': API.getEventEntity
  })

  App.globalChannel.reply('event:entity:edit', function () {
    return API.newEventEntity()
  })

  App.globalChannel.reply('event:entity:new', function () {
    return API.newEventEntity()
  })

  // hmmm

  return {
    Model: Event,
    Collection: EventsCollection
  }
//
}

module.exports = Events



// WEBPACK FOOTER //
// ./js/entities/events.js